import { criarClienteSupabase, type Db } from '@entregas/api';
import { config } from '../config';

let instancia: Db | null = null;

/** Cliente Supabase único do web (sessão no localStorage, padrão do supabase-js). */
export function obterDb(): Db {
  instancia ??= criarClienteSupabase({
    url: config.supabaseUrl,
    chaveAnon: config.supabaseChaveAnon,
    sessaoNaUrl: true,
  });
  return instancia;
}
